<template>
	<div class="panel_shouyin">
		<!-- <div class="titleLine">
			<el-row>
				<el-col :span="2" :offset="22">
				</el-col>
			</el-row>
		</div> -->
		<div class="listLine">
			<el-table :data="tableData" style="width: 100%">
				<!-- <el-table-column label="编码" width="50">
					<template slot-scope="props">
						{{parseInt(props.$index+1)}}
					</template>
				</el-table-column> -->
				<el-table-column label="病例单号" prop="caseNumber">
					<template slot-scope="props">
						<span @click="toBingliSee(props.row)" style="color:#1890FF;cursor: pointer;text-decoration: underline;">{{props.row.caseNumber}}</span>
					</template>
				</el-table-column>
				<el-table-column label="医生" prop="doctorName" width="150">
				</el-table-column>
				<el-table-column label="挂号时间" width="150">
					<template slot-scope="props">
						<div>{{$public.FTime(props.row.registrationTime,'YYYY-MM-DD HH:mm')}}</div>
					</template>
				</el-table-column>
				<el-table-column label="病例日期" width="130">
					<template slot-scope="props">
						<div>{{$public.FTime(props.row.caseDate,'YYYY-MM-DD')}}</div>
					</template>
				</el-table-column>
				<el-table-column label="检测" width="80">
					<template slot-scope="props">
						<div style="color:#FD4E4E">{{props.row.isInspect==0?'未检测':''}}</div>
						<div style="color:#18A44C">{{props.row.isInspect==1?'已检测':''}}</div>
					</template>
				</el-table-column>
				<el-table-column label="状态" width="80">
					<template slot-scope="props">
						<div style="color:#18A44C" v-if="props.row.isPay==true">已支付</div>
						<div style="color:#FD4E4E" v-else>未支付</div>
					</template>
				</el-table-column>
				<el-table-column label="备注" prop="remark" width="120">
				</el-table-column>
				<!-- <el-table-column label="操作" width="100">
					<template slot-scope="props">
						<el-button type="text" size="mini" @click="seePet(props.row)">查看</el-button>
					</template>
				</el-table-column> -->
				<span slot="empty">
					<img src="../../../../assets/img/konging.png" style="width:271px;margin-top:100px;"/>
					<div style="font-size: 16px;color:#999;margin:20px;">这个人什么痕迹都没留下</div>
				</span>
			</el-table>
		</div>
		<div class="pageLine">
			<page :page="page.page" :pageSize="page.pageSize" :total="page.total" @change="changePage"></page>
		</div>
		<bingliSee v-if="drawerJiyangPetSee_state" :curItem="curItem" @close="submit_drawerJiyangPetSee"></bingliSee>
	</div>
</template>
<script>
	import page from "../../../../components/page.vue"
	import bingliSee from "../drawer/bingliSee.vue"
	export default {
		components:{page,bingliSee},
		data(){
			return{
				page:{
					page:1,
					pageSize:10,
					total:0
				},
				tableData:[],
				// seePet
				drawerJiyangPetSee_state:false,
				curItem:{}
			}
		},
		computed:{
			userInfo(){
				if(this.$store.state.mendian.userInfo._id){
					return this.$store.state.mendian.userInfo;
				}else{
					return {
						basic_info:{},
						card_info:{},
						company_info:{},
						operation_info:{},
						pets_info:[],
						club_card:{}
					}
				}
			},
			curPetId(){
				return this.$store.state.mendian.curPetId;
			},
			curPetInfo(){
				return this.$store.getters['mendian/curPetInfo'];
			},
			bingliParams(){
				return this.$store.state.yiliaoxin.bingliParams;
			},
		},
		watch:{
			curPetInfo(){
				this.getTableData()
			}
		},
		mounted(){
			this.getTableData();
		},
		methods: {
			toBingliSee(row){
				let index = "/yiliaoxin"
				let str = "医疗工作台"
				this.$store.commit("setCurNavIndex_"+index.split('/')[1],{title:str,path:index})
				this.$router.push({path:index})
				
				this.bingliParams.curRow = row
				this.bingliParams.type = "see"
				this.$store.commit("yiliaoxin/set_bingliParams",this.bingliParams)
				this.$store.commit('yiliaoxin/set_curBusiness','病例')
			},
			seePet(row){
				this.drawerJiyangPetSee_state = true;
				this.curItem = row;
			},
			submit_drawerJiyangPetSee(){
				this.drawerJiyangPetSee_state = false;
			},
			changePage(num){
				this.page.page = num;
				this.getTableData();
			},
			// 获取寄养列表
			getTableData() {
				let loading=this.$loading();
				let params = {
					"keyword": '',
					"departmentId": '', 
					"petId": this.curPetId,
					isPay:-1, // -1不限；0未支付；1已支付
					isInspect:-1,  // -1不限；0未检测；1已检测
					isVisit:-1,  // -1不限；0未回访；1已回访
					isEnter:-1,  
					showLater:false,
					"desc": true, // true  倒序  false 正序
					"begin_time": "",
					"end_time": "",
					"pageIndex": this.page.page,
					"pageSize": this.page.pageSize,
				}
				// if(this.datetimerange&&this.datetimerange.length==2){
				// 	params.begin_time=(''+new Date(this.datetimerange[0]).getTime()).substr(0,10);
				// 	params.end_time=(''+new Date(this.datetimerange[1]).getTime()).substr(0,10);
				// }
				console.log(params)
				this.$http.post('/api/Case/List', params).then(res => {
					loading.close()
					if (res.code == 0) {
						this.tableData = res.data.data;
						this.page.total = res.data.count;
					}
				})
			},
		},
	}
</script>
<style scoped lang="scss">
.panel_shouyin{
	height: 100%;background-color: #fff;padding:0px 0 0;box-sizing: border-box;overflow: auto;position: relative;
	.titleLine{
		width:100%;
		background-color: #fff;
		padding:8px 8px 8px;
		box-sizing: border-box;
		margin-bottom: 4px;
		
	}
	.listLine{
		height: 100%;padding:0 0px 60px 0px;box-sizing: border-box;
	}
	.pageLine{
		position: absolute;bottom:0;z-index: 1;width:100%;padding:10px;background-color: #fff;box-sizing: border-box;
	}
}
</style>
